import { Drawer } from '@mui/material';
import { ReactNode } from 'react';

export type DrawerProps = {
  drawer: boolean;
  children: ReactNode;
  hideBackdrop?: boolean;
  setDrawer?: () => void;
  onClick?: () => void;
  className?: string;
  height?: string;
};
export function DrawerComponent({
  drawer,
  setDrawer,
  onClick,
  children,
  hideBackdrop,
  height,
  className
}: DrawerProps) {
  return (
    <Drawer
      anchor="bottom"
      open={drawer}
      onClose={setDrawer}
      onClick={onClick}
      className={className}
      hideBackdrop={hideBackdrop}
      ModalProps={{
        sx: {
          zIndex: 10,
          position: 'relative'
        }
      }}
      PaperProps={{
        sx: {
          width: '100%',
          height: height ?? '260px',
          borderRadius: '16px 16px 0px 0px',
          padding: '16px 32px 16px 32px',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }
      }}
    >
      {children}
    </Drawer>
  );
}
